import script from "./CategoryCreateModal.vue?vue&type=script&setup=true&lang=js"
export * from "./CategoryCreateModal.vue?vue&type=script&setup=true&lang=js"

import "./CategoryCreateModal.vue?vue&type=style&index=0&id=72713402&scoped=true&lang=css"

import exportComponent from "../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-72713402"]])

export default __exports__